import React from "react";
import "../assets/styles/Icon.css";

function Icon({ icon, className, style }) {
  return <i className={`icon ${icon}${className ? ` ${className}` : ""}`} style={style}></i>;
}

export default Icon;
